import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { setNewOrderCategory } from "common/actions";
import { getTabColor, getTabTextColor } from "common/store";

class ModalTabSort extends React.Component<
  {
    categories: any;
    setNewOrderCategory: (newOrder: string[]) => void;
    onClose: () => void;
  },
  {}
> {
  _onClickChange(changeIndex) {
    const { order } = this.props.categories;
    const newOrder = [...order];
    const tmp = newOrder[changeIndex];
    newOrder[changeIndex] = newOrder[changeIndex - 1];
    newOrder[changeIndex - 1] = tmp;
    this.props.setNewOrderCategory(newOrder);
  }

  render() {
    const { categories } = this.props;
    return (
      <Wrapper>
        <div className="content">
          <h2 className="title">タブの並び替え</h2>
          <div className="tabs">
            {categories.order.map((catId, index) => {
              const catName = categories.list[catId].name;
              const backgroundColor = getTabColor(catId);
              const color = getTabTextColor(catId);
              return (
                <React.Fragment key={catId}>
                  <div
                    className="tab"
                    style={{
                      backgroundColor,
                      color,
                    }}
                  >
                    {catName}
                    {index !== 0 && (
                      <button
                        className="change"
                        onClick={() => this._onClickChange(index)}
                      >
                        <i className="fas fa-exchange-alt" />
                      </button>
                    )}
                  </div>
                </React.Fragment>
              );
            })}
          </div>
          <button className="close" onClick={() => this.props.onClose()}>
            閉じる
          </button>
        </div>
      </Wrapper>
    );
  }
}

export default connect(({ categories }) => ({ categories }), {
  setNewOrderCategory,
})(ModalTabSort);

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);

  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  .content {
    background-color: #fff;
    width: 400px;
    margin: 32px auto;
    text-align: center;
    padding: 32px;
    box-sizing: border-box;
    border-radius: 8px;
  }
  .title {
    font-size: 20px;
  }
  .tabs {
    margin: 32px auto;
    width: 300px;
  }
  .tab {
    padding: 16px;
    font-size: 16px;
    color: #fff;
    text-align: left;
    border-radius: 2px;
    margin-bottom: 8px;
    position: relative;
  }

  .change {
    position: absolute;
    width: 60px;
    height: 30px;
    top: -19px;
    left: calc(50% - 30px);
    display: flex;
    background-color: #ddd;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    i {
      color: #333;
      transform-origin: center;
      transform: rotate(90deg);
    }
  }

  .close {
    background-color: #ddd;
    padding: 8px 16px;
    border-radius: 4px;
  }
`;
